import { NgModule } from '@angular/core';
import { AuthGuard } from '@app/modules/auth/guard/auth.guard';
import { AuthRoutingModule } from '@app/modules/auth/router';
import { SharedModule } from '@app/shared';
import { AuthService } from '@app/modules/auth/service/auth.service';
import { AuthState } from '@app/modules/auth/store/auth.state';
import { NgxsModule } from '@ngxs/store';
import { LoginPageComponent } from '@app/modules/auth/page/login/login.component';
import { RegistrationPageComponent } from '@app/modules/auth/page/registration/registration.component';
import { PasswordRestorePageComponent } from '@app/modules/auth/page/password-restore/password-restore.component';
import { AuthLayoutComponent } from '@app/modules/auth/layout/auth-layout.component';
import { LoginFormComponent } from '@app/modules/auth/part/login-form/login-form.component';
import { RegistrationFormComponent } from '@app/modules/auth/part/registration-form/registration-form.component';
import { RegistrationWithpinFormComponent } from '@app/modules/auth/part/registration-withpin-form/registration-withpin-form.component';
import { PasswordRestoreFormComponent } from '@app/modules/auth/part/password-restore-form/password-restore-form.component';
import { PasswordRestoreWithpinFormComponent } from '@app/modules/auth/part/password-restore-withpin-form/password-restore-withpin-form.component';
import { RegistrationConfirmPageComponent } from '@app/modules/auth/page/registration-confirm/registration-confirm.component';
import { RegistrationWithpinConfirmPageComponent } from '@app/modules/auth/page/registration-withpin-confirm/registration-withpin-confirm.component';
import { RegistrationConfirmFormComponent } from '@app/modules/auth/part/registration-confirm-form/registration-confirm-form.component';
import { RegistrationWithpinConfirmFormComponent } from '@app/modules/auth/part/registration-withpin-confirm-form/registration-withpin-confirm-form.component';
import { PasswordRestoreWithpinConfirmFormComponent } from '@app/modules/auth/part/password-restore-withpin-confirm-form/password-restore-withpin-confirm-form.component';
import { SelectRolePageComponent } from '@app/modules/auth/page/select-role/select-role.component';
import { SelectRoleFormComponent } from '@app/modules/auth/part/select-role-form/select-role-form.component';

const imports = [
  SharedModule,
  AuthRoutingModule,
  NgxsModule.forFeature([AuthState]),
];

const declarations = [
  LoginPageComponent,
  LoginFormComponent,
  AuthLayoutComponent,
  RegistrationPageComponent,
  RegistrationFormComponent,
  RegistrationWithpinFormComponent,
  RegistrationConfirmPageComponent,
  RegistrationWithpinConfirmPageComponent,
  RegistrationConfirmFormComponent,
  RegistrationWithpinConfirmFormComponent,
  PasswordRestorePageComponent,
  PasswordRestoreFormComponent,
  PasswordRestoreWithpinFormComponent,
  PasswordRestoreWithpinConfirmFormComponent,
  SelectRolePageComponent,
  SelectRoleFormComponent,
];

const providers = [
  AuthGuard,
  AuthService,
];

@NgModule({
  imports,
  declarations,
  providers
})
export class AuthModule { }
